export class ContactResultModel {
  public success: boolean;
  public userId: string;
}

export class ContactModel {
  public site: string;
  public email: string;
  public firstname: string;
  public lastname: string;
  public company: string;
  public message: string;
  public phone: string;
}
